import cx from "clsx"
import { Flex, Text, Title } from "components/common"
import { IconText } from "components/custom"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import { localisedValue } from "utils"
import styles from "../index.module.less"

const INITIAL_DISPLAY_COUNT = 5

const AmenitiesSection = ({ project }) => {
  const { t } = useTranslation()
  const [showAll, setShowAll] = useState(false)

  const allAmenities = project?.amenities || []
  const amenitiesToShow = showAll ? allAmenities : allAmenities.slice(0, INITIAL_DISPLAY_COUNT)
  const hasMore = allAmenities.length > INITIAL_DISPLAY_COUNT

  if (!allAmenities.length) return null

  return (
    <Flex className="w-100" vertical gap={12}>
      <Title level={4} className="mbe-16">
        {t("Features & Amenities")}
      </Title>
      <div className={styles.amenitiesGrid}>
        {amenitiesToShow.map(amenity => {
          const amenityName = localisedValue({ object: amenity, key: "name" })
          return (
            <Flex key={amenity.id} align="center" gap={8} className={cx(styles.amenityItem, "p-0")}>
              <IconText
                icon="TiTick"
                title={amenityName}
                iconProps={{ size: 16, style: { color: "#52c41a" } }}
                titleProps={{ style: { fontSize: "13px", color: "#595959" } }}
              />
            </Flex>
          )
        })}
        {hasMore && (
          <Flex
            align="center"
            gap={8}
            className={`${styles.amenityItem} pointer`}
            onClick={() => setShowAll(prev => !prev)}
          >
            <Text type="primary" className="fs13">
              {showAll ? t("View Less") : `+${allAmenities.length - INITIAL_DISPLAY_COUNT} ${t("more")}`}
            </Text>
          </Flex>
        )}
      </div>
    </Flex>
  )
}

export default AmenitiesSection
